export interface PointerPosition {
  x: number;
  y: number;
}

export const DRAG_TOLERANCE_PX = 4;

export const isDragGesture = (
  origin: PointerPosition | null,
  current: PointerPosition
): boolean =>
  origin !== null &&
  (Math.abs(current.x - origin.x) > DRAG_TOLERANCE_PX ||
    Math.abs(current.y - origin.y) > DRAG_TOLERANCE_PX);
